var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToggleBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 30,
    viewBox: "0 0 108 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_636_161811)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 0.500977,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 0.500977,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#D6E6FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88 14.001H90V16.001H88V14.001ZM92 14.001H94V16.001H92V14.001ZM96 14.001H98V16.001H96V14.001Z",
    fill: "#116DFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_636_161811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 30.0002,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleBtn);
export default __webpack_public_path__ + "static/media/toggle_btn.432843279f996af55d5ff21f39a3cd55.svg";
export { ForwardRef as ReactComponent };